<template>
  <v-alert
    :value="true"
    type="info"
    icon="bug_report"
    outline
    class="beta-notice">
    <div class="beta-notice__content">
      <span class="beta-notice__header">this feature is in beta testing</span>
      <v-divider />
      <span>Some parts of it may not work properly, or at all, and some information may be incomplete.</span>
      <report-bug-form>
        <a slot="activator">Please report any bugs you encounter using this form.</a>
      </report-bug-form>
    </div>
  </v-alert>
</template>

<script>
import ReportBugForm from './ReportBugForm.vue';

export default {
  name: 'BetaNotice',
  components: {
    ReportBugForm,
  },
  data() {
    return {
      //
    };
  },
};
</script>

<style lang="stylus" scoped>
@require('../stylus/base')

.beta-notice
  &__content
    display: flex
    flex-flow: column nowrap
    align-items: stretch
  &__header
    font-size: 1.1rem
    font-weight: $base-header-font-weight
    text-transform: uppercase;
    @media screen and (max-width: 48rem)
      font-size: inherit
</style>
